import axios from 'axios';

let executing = false;
const queue = [];
export const checkauhtoken =async () => {
    if (!executing) {
        executing = true;
        try {
            const headers = {
                'Content-Type': 'application/json',
                'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
            }
        
            const response = await axios.get(process.env.REACT_APP_API_URL + 'getUserDetails', { headers: headers })
                if (response.data.message === 'User auth token not provided or invalid' || response.data.message === 'User auth token invalid, Refreshing the token') {
                    try{
                        const headers = {
                            'Content-Type': 'application/json',
                            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                            'userrefreshtoken': 'Bearer ' +  window.sessionStorage.getItem("jwt_refresh_token")
                        }
                        const response = await axios.get(process.env.REACT_APP_API_URL + 'auth/refreshauthtoken', { headers: headers })
                        const res = response.data;
                        if(res.code=="200"){
                            window.sessionStorage.setItem("user_jwt", res.data.jwt_token);
                            window.sessionStorage.setItem("jwt_refresh_token", res.data.jwt_refresh_token);
                            window.location.reload();
                        }else{
                                window.sessionStorage.removeItem("user_id");
                                window.sessionStorage.removeItem("user_jwt");
                                window.sessionStorage.removeItem("jwt_refresh_token");
                                window.sessionStorage.removeItem("register_user_id");
                                window.sessionStorage.removeItem("register_user_email");
                                window.sessionStorage.removeItem("temp_login_id");
                                window.sessionStorage.removeItem("temp_user_email");
                        
                                if (window.sessionStorage.getItem("demouser") === "Yes") {
                                    window.sessionStorage.removeItem("demouser");
                                    window.location.href = process.env.REACT_APP_SITE_URL + "demologin";
                                } else {
                                    window.sessionStorage.removeItem("demouser");
                                    window.location.href = process.env.REACT_APP_SITE_URL + "login";
                                }
                            }
                        
                    } catch (error) {
                        console.error('Error checking refresh token validity:', error);
                    }
                    
                } else {
                }
        
        } catch (error) {
            console.error('Error checking access token validity:', error);
        }

        executing = false;
        if (queue.length > 0) {
            const nextFunction = queue.shift();
            nextFunction();
        }
    }else{
        queue.push(checkauhtoken);
    }
  };
  